import { Controller } from "@hotwired/stimulus";

// GR-1756: shows the session / page picker matching the selected
// deep-link target type on the app notification form. Mirrors
// TrackFilterToggleController's wrapper handling so hidden selects
// collapse their whole FormControl group.
export class DeepLinkTargetToggleController extends Controller {
  static targets = ["typeSelect", "session", "page"];

  connect() {
    this.setVisibility();
  }

  setVisibility() {
    const type = this.typeSelectTarget.value;
    this.toggleAll(this.sessionTargets, type === "agenda_session");
    this.toggleAll(this.pageTargets, type === "page");
  }

  toggleAll(elements, visible) {
    elements.forEach((el) => {
      const wrapper = el.closest(".FormControl") || el.parentElement;

      el.hidden = !visible;
      if (wrapper) {
        if (visible) {
          wrapper.style.removeProperty("display");
        } else {
          wrapper.style.display = "none";
        }
      }
    });
  }
}
